import {handleValidationChange} from '../CommonValidation';

export const validateGatePass = (data, items, setIsError) => {
    var isValid = true;


    // if(data.transfer_date === "") {
    //     handleValidationChange("transfer_date", true, setIsError);
    //     isValid=false;
    // } else {
    //     handleValidationChange("transfer_date", false, setIsError);
    // }

    // if(data.transfer_number === "" || data.transfer_number === undefined || data.transfer_number === null) {
    //     handleValidationChange("transfer_number", true, setIsError);
    //     isValid=false;
    // } else {
    //     handleValidationChange("transfer_number", false, setIsError);
    // }

    // if(data.branch_from === "" || data.branch_from === undefined) {
    //     handleValidationChange("branch_from", true, setIsError);
    //     isValid=false;
    // } else {
    //     handleValidationChange("branch_from", false, setIsError);
    // }

    if(data.transfer_time === "" || data.transfer_time === undefined) {
        handleValidationChange("transfer_time", true, setIsError);
        isValid=false;
    } else {
        handleValidationChange("transfer_time", false, setIsError);
    }

    if(items.length < 1) {
        handleValidationChange("list", true, setIsError);
        isValid=false;
    } else {
        handleValidationChange("list", false, setIsError);
    }

    items.map((data) => {
        if(data.qty === "" || data.qty === undefined) {
            handleValidationChange("qty", true, setIsError);
            isValid=false;
        } else {
            handleValidationChange("qty", false, setIsError);
        }

        if(data.unit === "" || data.unit === undefined) {
            handleValidationChange("unit", true, setIsError);
            isValid=false;
        } else {
            handleValidationChange("unit", false, setIsError);
        }
        
        if(data.description === "" || data.description === undefined) {
            handleValidationChange("description", true, setIsError);
            isValid=false;
        } else {
            handleValidationChange("description", false, setIsError);
        }
        
        if(data.consignment_no === "" || data.consignment_no === undefined) {
            handleValidationChange("consignment_no", true, setIsError);
            isValid=false;
        } else {
            handleValidationChange("consignment_no", false, setIsError);
        }
        
    })


    return isValid
  
}
